export default __webpack_public_path__ + "fonts/Inter-Regular.woff2";